
var customSwitcherBox = {

    engraveLimit: undefined,
    showExtraFields: undefined,
    primaryInputLabel: undefined,
    secondaryInputLabel: undefined,
    thirdInputLabel: undefined,
    propertiesMultiple: 'text',
  	map: undefined,

    initEngravingFontChooser() {
        $(".engrave-font-chooser-item").on("click", function() {
          
            let container = $(this).closest('form');

            container.find('.engrave-font-chooser-item').not(this).removeClass('font-selected');
            $(this).addClass("font-selected");
            container.find("#engraving-font").val($(this).data("font"));
			
          	$('.open-product').find('.prop-type--Font span').html($(this).data("font"))
            container.find(".input-container-switch, .engrave-text-switch-cont").removeClass(function(index, css) {
                return (css.match(/\bengrave-font\S+/g) || []).join(' '); // removes anything that starts with "itemnx"
            });
            var fontClass = $(this).data("font").replace(/\s+/g, '-').toLowerCase();
            container.find('.input-container-switch, .engrave-text-switch-cont').addClass("engrave-font-" + fontClass);
            if (container.find('.input-container-switch').hasClass("engrave-font-standard")) {
                container.find(".engrave-font-disc-text").hide();
                container.find(".input-sub").show();
            } else {
                container.find(".engrave-font-disc-text").show();
                container.find(".input-sub").hide();
            }
          drawStack();
        });
    },

    initButtons() {
        $(document).ready(function() {
            if (window.location.href.indexOf("?morse") > -1) {
                $(".morse-btn").click();
            } else if (window.location.href.indexOf("?text") > -1) {
                $(".text-btn").click();
            } else if (window.location.href.indexOf("?coords") > -1) {
                $(".coords-btn").click();
            }

        });
      
            
        var text_max = $('#text-engrave').attr('maxlength');
    	$('.text-engrave-remaining').html(text_max + ' characters remaining');
        $('#text-engrave').keyup(function() {
            var text_length = $('#text-engrave').val().length;
            var text_remaining = text_max - text_length;


            $('.text-engrave-remaining').html(text_remaining + ' characters remaining');
                if (text_remaining < 8){
            $('.text-engrave-remaining').css("color", "orange");
          } else if(text_remaining == 0){
            $('.text-engrave-remaining').css("color", "red");
          }
        });

        $(".coords-btn").click(function() {
            let container = $(this).closest('form');
            container.find("#morse-code").attr('name', '');
            container.find("#engraving-font").attr('name', 'properties[Font]');

            container.find(".coordinates-variant").show();
            container.find(".morse-variant").hide();
            container.find(".engrave-text-cont").hide();
            container.find(".engrave-font-chooser-wrapper").show();
          
          	
          	container.closest('.custom-bundle-form-item').find('.prop-type--Morse.code').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Text').remove();


            container.find(".text-engrave").removeClass("line-item-property__field");
          container.find("#morse-code").attr('name', '');
            container.find(".text-engrave-left").removeClass("line-item-property__field");
            container.find(".morse-property").removeClass("line-item-property__field");
            container.find(".text-engrave:not(.multiple-eng-hide-spec) input").attr('name', '');
          
          	container.find(".text-input-limit .text-engrave:not(.multiple-eng-hide-spec) textarea").attr('name', '');
            container.find(".text-engrave-left input").attr('name', '');
            container.find(".maps-latitude input").attr('name', 'properties[Latitude]');
            container.find(".maps-longitude input").attr('name', 'properties[Longitude]');


            container.find(".text-btn").removeClass("active-switcher");
            container.find(".coords-btn").addClass("active-switcher");
            container.find(".morse-btn").removeClass("active-switcher");
            container.find(".dynamic-landing-heading-hide").show();
            container.find(".dynamic-landing-heading-edit:not(.land-head-no-change)").text('4. Select your color')

        });


        $(".text-btn").click(function() {
            let container = $(this).closest('form');
            container.find(".maps-latitude input").attr('name', '');
            container.find(".maps-longitude input").attr('name', '');
            container.find(".text-engrave").addClass("line-item-property__field");
            container.find(".text-engrave-left").addClass("line-item-property__field");

			container.closest('.custom-bundle-form-item').find('.prop-type--Latitude').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Longitude').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Morse.code').remove();
          

            container.find(".text-engrave:not(.multiple-eng-hide-spec) input").attr('name', 'properties[' + customSwitcherBox.propertiesMultiple + ']');
			container.find(".text-input-limit .text-engrave:not(.multiple-eng-hide-spec) textarea").attr('name', 'properties[' + customSwitcherBox.propertiesMultiple + ']');
            container.find(".morse-property").removeClass("line-item-property__field");
            container.find(".coordinates-variant").hide();
            container.find(".morse-variant").hide();
            container.find(".engrave-text-cont").show();
          	container.find("#morse-code").attr('name', '');
            container.find(".engrave-font-chooser-wrapper").show();



            container.find(".dynamic-landing-heading-hide").show();
            container.find(".dynamic-landing-heading-edit:not(.land-head-no-change)").text('4. Select your color')
            container.find(".text-btn").addClass("active-switcher");
            container.find(".coords-btn").removeClass("active-switcher");
            container.find(".morse-btn").removeClass("active-switcher");

            container.find('.text-input-limit').keyup(function(e) {
                console.log("text-input running");
                if (e.keyCode === 8) return; // Backspace
                var new_stuff = $(this).val();
                new_stuff = new_stuff.replace(/[\n\r]+/g, ""); // clean out newlines, so we dont get dups!
                new_stuff = new_stuff.replace(/(.{12})/g, "$1\r");
                $(this).val(new_stuff);
            });
            container.find("#line-item-dynamic input").attr('name', 'properties[Font]');

        });

        $(".morse-btn").click(function() {
            let container = $(this).closest('form');
            container.find(".maps-latitude input").attr('name', '');
            container.find(".maps-longitude input").attr('name', '');

            container.find(".coordinates-variant").hide();
            container.find(".morse-variant").show();
            container.find(".engrave-text-cont").hide();
          
          
          	container.closest('.custom-bundle-form-item').find('.prop-type--Latitude').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Longitude').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Text').remove();

            container.find(".text-engrave").removeClass("line-item-property__field");
            container.find(".text-engrave-left").removeClass("line-item-property__field");
            container.find(".engrave-font-chooser-wrapper").hide();

            container.find("#line-item-dynamic input").attr('name', '');
            container.find('.barEngraveExtraOpt').attr('name', '');
            container.find('.text-engrave-left input').attr('name', '');
            container.find('#text-engrave').attr('name', '');
            container.find(".dynamic-landing-heading-hide").hide();
            container.find(".dynamic-landing-heading-edit").text('3. Select your color')
            container.find("#morse-code").attr('name', 'properties[Morse code]');
            container.find(".morse-property").addClass("line-item-property__field");

            container.find('.morse-variant').show();
            container.find(".text-btn").removeClass("active-switcher");
            container.find(".coords-btn").removeClass("active-switcher");
            container.find(".morse-btn").addClass("active-switcher");

        });
    }
};














var morseCode = {
  init () {
    $('[id=morse]').on('keyup', function () {
      let container = $(this).closest('form');
      if (container.length == 0) {
        container = $('body');
      }
      var value  = $(this).val();
      var output = '';
      if (value === '') {
        container.find('#text').text('');
      }
      for (var i = 0; i < value.length; i++) {
        output += morseCode.converter[value.charAt(i).toLowerCase()];
      }
      container.find('#morse-text').text(output);
      container.find('#morse-code').val(output);
    });
  },
  
  converter: {
    'a': '.- ',
    'b': '-... ',
    'c': '-.-. ',
    'd': '-.. ',
    'e': '. ',
    'f': '..-. ',
    'g': '--. ',
    'h': '.... ',
    'i': '.. ',
    'j': '.--- ',
    'k': '-.- ',
    'l': '.-.. ',
    'm': '-- ',
    'n': '-. ',
    'o': '--- ',
    'p': '.--. ',
    'q': '--.- ',
    'r': '.-. ',
    's': '... ',
    't': '- ',
    'u': '..- ',
    'v': '...- ',
    'w': '.-- ',
    'x': '-..- ',
    'y': '-.-- ',
    'z': '--.. ',
    '1': '.---- ',
    '2': '..--- ',
    '3': '...-- ',
    '4': '....- ',
    '5': '..... ',
    '6': '-.... ',
    '7': '--... ',
    '8': '---.. ',
    '9': '----. ',
    '0': '----- ',
    '.': '.-.-.- ',
    ',': '--..-- ',
    '?': '..--.. ',
    "'": '.----. ',
    '!': '-.-.-- ',
    '/': '-..-. ',
    '(': '-.--. ',
    ')': '-.--.- ',
    '&': '.-... ',
    ':': '---... ',
    ';': '-.-.-. ',
    '=': '-...- ',
    '+': '.-.-. ',
    '-': '-....- ',
    '_': '..--.- ',
    '"': '.-..-. ',
    '$': '...-..- ',
    '@': '.--.-. ',
    ' ': '/',
    'א': '.- ',
    'ב': '-... ',
    'ס': '-.-. ',
    'ד': '-.. ',
    'ו': '. ',
    'ג': '--. ',
    'ח': '.... ',
    'י': '.. ',
    'ע': '.--- ',
    'כ': '-.- ',
    'ל': '.-.. ',
    'מ': '-- ',
    'נ': '-. ',
    'ה': '--- ',
    'פ': '.--. ',
    'ק': '--.- ',
    'ר': '.-. ',
    'ש': '... ',
    'ת': '- ',
    'ט': '..- ',
    'v': '...- ',
    'צ': '.-- ',
    'ז': '--.. ',
  }
}

$(document).ready(function() {
	morseCode.init();
    customSwitcherBox.initEngravingFontChooser();
    customSwitcherBox.initButtons();
});






















$(document).ready(function(){
  
   var  me = 'pk.eyJ1IjoiY3VzdG9tYXRlaWwiLCJhIjoiY2x1c2FkNnliMGg0NzJxdWoydG1qY3RzcCJ9.R30BlBpE2Dds_y39sPYqjg';
  mapboxgl.accessToken = me;
  var map = new mapboxgl.Map({
  container: 'map',
  center: [55.274387,25.197197],
  zoom: 8,
  style: {
    version: 8,
    sources: {
      osm: {
        type: 'raster',
        tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
        tileSize: 256,
        attribution: 'Map tiles by <a target="_top" rel="noopener" href="https://tile.openstreetmap.org/">OpenStreetMap tile servers</a>, under the <a target="_top" rel="noopener" href="https://operations.osmfoundation.org/policies/tiles/">tile usage policy</a>. Data by <a target="_top" rel="noopener" href="http://openstreetmap.org">OpenStreetMap</a>'
      }
    },            
    layers: [{
      id: 'osm',
      type: 'raster',
      source: 'osm',
    }],
  }
});
  
  function hex_to_ascii(str1)
 {
	var hex  = str1.toString();
	var str = '';
	for (var n = 0; n < hex.length; n += 2) {
		str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
	}
	return str;
 
}
  
  
  map.on('load', function () {
    geocoder.query('Tel-Aviv, israel'); // or wherever you want the marker to start
    $("#map").css("pointer-events","none");
  })
  function findLocation() {
    document.querySelector('.mapboxgl-ctrl-geocoder--input').id = 'mapbox-search';
    document.querySelector('.suggestions').id = 'suggestionsBox';
    geocoder.query(document.getElementById("mapbox-search").value);
    document.getElementById("suggestionsBox").style.display = 'none';
  }

  var checkbox = document.getElementById("map-lock-input");

  checkbox.addEventListener( 'change', function() {
    if(this.checked) {
      // Checkbox is checked..
      $("#map").css("pointer-events","auto");
    } else {
      // Checkbox is not checked..
      $("#map").css("pointer-events","none");
    }
  });



  var geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    //mode: 'mapbox.places-permanent', // does not provide POI data
    minLength:3,
    mapboxgl: mapboxgl,
    placeholder: 'רוטשילד 4, תל אביב...'
  });
  geocoder.on('result', function(ev) {
    var latString = ev.result.geometry.coordinates[1];
    var lngString = ev.result.geometry.coordinates[0];
    $('.mapboxgl-ctrl-geocoder--input').blur();

    var lat = JSON.stringify(latString);
    var lng = JSON.stringify(lngString);

    if (lat > 0) {
      lat = parseFloat(lat).toFixed(4) + "° N";
    } else {
      lat = parseFloat(lat).toFixed(4) + "° S";
    }
    if (lng > 0) {
      lng = parseFloat(lng).toFixed(4) + "° E";
    } else {
      lng = parseFloat(lng).toFixed(4) + "° W";
    }
    console.log(lat);
    console.log(lng);
    document.getElementById('latitude').value = lat;
    document.getElementById('longtitude').value = lng;
//      var text = $(document.getElementById("longtitude"));
//     var two= $("#latitude").val();
//     two = "";
//     console.log(text);
  });

  map.on('click', function (e) {
    if (geocoder.mapMarker) {
      geocoder.mapMarker.setLngLat(e.lngLat);
      var lat = JSON.stringify(e.lngLat.lat);
      var lng = JSON.stringify(e.lngLat.lng);
      if (lat > 0) {
        lat = parseFloat(lat).toFixed(4) + "° N";
      } else {
        lat = parseFloat(lat).toFixed(4) + "° S";
      }
      if (lng > 0) {
        lng = parseFloat(lng).toFixed(4) + "° E";
      } else {
        lng = parseFloat(lng).toFixed(4) + "° W";
      }
      console.log(lat);
      console.log(lng);
      document.getElementById('latitude').value = lat;
      document.getElementById('longtitude').value = lng;
    } else {
      var marker = new geocoder.mapMarker.setLngLat(e.lngLat);
      console.log('test');
    }

  });

  map.addControl(new mapboxgl.NavigationControl());
  document.getElementById('geocoder').appendChild(geocoder.onAdd(map));
  
       
 var text = $("#text-engrave").val();
   
  $ (console.log(text));
  if (text != "") {
    var one =$("#longtitude").val();
    var two= $("#latitude").val();
    one = "";
    two = "";
    console.log("one")
  }else {
  console.log("none");
  };     
            
         
  
  

  
});
